import { render, staticRenderFns } from "./modalCopyTeamDeal.vue?vue&type=template&id=6d640ded&"
import script from "./modalCopyTeamDeal.vue?vue&type=script&lang=js&"
export * from "./modalCopyTeamDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports